"use strict";
/*
 * Created on 23. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Release part action result converter.
 *
 * @author Radek Beran
 */


var ReleasePartActionResultConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleasePartActionResultConverter, _DataObjectConverter_);

  function ReleasePartActionResultConverter() {
    _classCallCheck(this, ReleasePartActionResultConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleasePartActionResultConverter).apply(this, arguments));
  }

  return ReleasePartActionResultConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleasePartActionResultConverter = ReleasePartActionResultConverter;